'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoThermometer = function IoThermometer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 26.3c1.6 1 2.6 2.9 2.6 5 0 3.4-2.8 6.2-6.2 6.2s-6.3-2.8-6.3-6.2c0-2.2 1-4 2.6-5.1v-20.1c0-2 1.6-3.6 3.7-3.6s3.6 1.6 3.6 3.6v20.2z m-4.8-20.2v3.9h2.3v-3.9c0-0.6-0.5-1.1-1.1-1.1s-1.2 0.5-1.2 1.1z m2.4 16.4v-1.2h-1.2v1.2h1.2z m0-2.5v-5h-1.2v5h1.2z' })
        )
    );
};

exports.default = IoThermometer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/thermometer.js
// module id = 2534
// module chunks = 0